import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './InvoiceStatusBadge.styles';
import { InvoiceStatus } from '@/features/Profile/sections/Invoices/api';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

const STATUS_LABEL_KEY: Record<InvoiceStatus, string> = {
  [InvoiceStatus.Paid]: 'common.paid',
  [InvoiceStatus.Unpaid]: 'common.unpaid',
  [InvoiceStatus.Canceled]: 'common.cancelled',
  [InvoiceStatus.Overdue]: 'common.expired',
  [InvoiceStatus.Revoked]: 'common.revoked',
};

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation();

  return <S.Status $status={status}>{t(STATUS_LABEL_KEY[status])}</S.Status>;
}
